import { CheckCircle2, Clock, Shield, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function OurProvenMigrationFramework() {
  const frameworks = [{
    id: 1,
    title: "Rapid Assessment Framework",
    description: "Quickly evaluate your current GP system and identify migration requirements with our proven assessment methodology.",
    icon: Clock,
    cta: "Learn More",
    link: "/OurServicesPage"
  }, {
    id: 2,
    title: "Data Migration Framework",
    description: "Ensure clean, accurate data transfer with audit-ready reports and mapped fields for seamless Business Central integration.",
    icon: CheckCircle2,
    cta: "Explore Process",
    link: "/OurServicesPage"
  }, {
    id: 3,
    title: "Security & Compliance Framework",
    description: "Maintain data integrity and regulatory compliance throughout the migration with built-in security protocols.",
    icon: Shield,
    cta: "View Details",
    link: "/OurServicesPage"
  }, {
    id: 4,
    title: "Accelerated Deployment Framework",
    description: "Fast-track your migration with our streamlined deployment process, minimizing downtime and business disruption.",
    icon: Zap,
    cta: "Get Started",
    link: "/ContactPage"
  }];
  return <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mb-12 lg:mb-16">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl mb-4 animate-fade-in-up">
            Our Proven Migration Framework
          </h2>
          <p className="text-lg text-foreground/70 animate-fade-in-up-delay-100">
            Four specialized frameworks designed to deliver fast, reliable ERP
            migration with audit-ready results across North America.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-2 xl:gap-10">
          {frameworks.map((framework, i) => {
          const IconComponent = framework.icon;
          return <Card key={framework.id} data-index={i} className="border border-border shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] bg-card animate-fade-in-up-delay-200">
                <CardHeader>
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-md bg-primary/10">
                    <IconComponent className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {framework.title}
                  </CardTitle>
                  <CardDescription className="text-foreground/70">
                    {framework.description}
                  </CardDescription>
                </CardHeader>
                <CardFooter>
                  <Link to={framework.link} className="w-full">
                    <Button variant="outline" className="w-full border-primary/20 hover:bg-primary/5 hover:border-primary/40 transition-all duration-[var(--duration-fast)]">
                      {framework.cta}
                    </Button>
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>

        <div className="mt-12 text-center animate-fade-in-up-delay-200">
          <Link to="/PricingPage">
            <Button size="lg" className="bg-accent hover:bg-accent-hover shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
              View Pricing Tiers
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}